var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGflArenaIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "158px",
    height: "158px",
    viewBox: "0 0 158 158",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "37.9433832%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A566",
    stopOpacity: 0.444479349,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL--Arena---Version-2.0",
    transform: "translate(-970, -6492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(970, 6492)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 79,
    cy: 79,
    r: 79
  }), /*#__PURE__*/React.createElement("g", {
    id: "featured_seasonal_and_gifts_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24",
    transform: "translate(39, 37)",
    fill: "#C6A566",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,85 L8.1,40.4761905 L0,40.4761905 L0,16.1904762 L21.06,16.1904762 C20.7225,15.5833333 20.503125,14.9424603 20.401875,14.2678571 C20.300625,13.593254 20.25,12.8849206 20.25,12.1428571 C20.25,8.76984127 21.43125,5.90277778 23.79375,3.54166667 C26.15625,1.18055556 29.025,0 32.4,0 C33.9525,0 35.40375,0.286706349 36.75375,0.860119048 C38.10375,1.43353175 39.3525,2.22619048 40.5,3.23809524 C41.6475,2.15873016 42.89625,1.34920635 44.24625,0.80952381 C45.59625,0.26984127 47.0475,0 48.6,0 C51.975,0 54.84375,1.18055556 57.20625,3.54166667 C59.56875,5.90277778 60.75,8.76984127 60.75,12.1428571 C60.75,12.8849206 60.6825,13.5763889 60.5475,14.2172619 C60.4125,14.8581349 60.21,15.515873 59.94,16.1904762 L81,16.1904762 L81,40.4761905 L72.9,40.4761905 L72.9,85 L8.1,85 Z M48.6,8.0952381 C47.4525,8.0952381 46.490625,8.48313492 45.714375,9.25892857 C44.938125,10.0347222 44.55,10.9960317 44.55,12.1428571 C44.55,13.2896825 44.938125,14.2509921 45.714375,15.0267857 C46.490625,15.8025794 47.4525,16.1904762 48.6,16.1904762 C49.7475,16.1904762 50.709375,15.8025794 51.485625,15.0267857 C52.261875,14.2509921 52.65,13.2896825 52.65,12.1428571 C52.65,10.9960317 52.261875,10.0347222 51.485625,9.25892857 C50.709375,8.48313492 49.7475,8.0952381 48.6,8.0952381 Z M28.35,12.1428571 C28.35,13.2896825 28.738125,14.2509921 29.514375,15.0267857 C30.290625,15.8025794 31.2525,16.1904762 32.4,16.1904762 C33.5475,16.1904762 34.509375,15.8025794 35.285625,15.0267857 C36.061875,14.2509921 36.45,13.2896825 36.45,12.1428571 C36.45,10.9960317 36.061875,10.0347222 35.285625,9.25892857 C34.509375,8.48313492 33.5475,8.0952381 32.4,8.0952381 C31.2525,8.0952381 30.290625,8.48313492 29.514375,9.25892857 C28.738125,10.0347222 28.35,10.9960317 28.35,12.1428571 Z M8.1,24.2857143 L8.1,32.3809524 L36.45,32.3809524 L36.45,24.2857143 L8.1,24.2857143 Z M36.45,76.9047619 L36.45,40.4761905 L16.2,40.4761905 L16.2,76.9047619 L36.45,76.9047619 Z M44.55,76.9047619 L64.8,76.9047619 L64.8,40.4761905 L44.55,40.4761905 L44.55,76.9047619 Z M72.9,32.3809524 L72.9,24.2857143 L44.55,24.2857143 L44.55,32.3809524 L72.9,32.3809524 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGflArenaIcon1);
export default __webpack_public_path__ + "static/media/gfl-arena-icon1.9f4e2a3f9c02a5b02bc68db9a297a8e5.svg";
export { ForwardRef as ReactComponent };